<template>
  <div class="row csat--metrics-container">
    <csat-metric-card
      :label="$t('CSAT_REPORTS.METRIC.TOTAL_SEND_MESSAGES.LABEL')"
      :info-text="$t('CSAT_REPORTS.METRIC.TOTAL_SEND_MESSAGES.TOOLTIP')"
      :value="totalSentMessagesCount"
    />
    <csat-metric-card
      :label="$t('CSAT_REPORTS.METRIC.TOTAL_RESPONSES.LABEL')"
      :info-text="$t('CSAT_REPORTS.METRIC.TOTAL_RESPONSES.TOOLTIP')"
      :value="responseCount"
    />
    <csat-metric-card
      :disabled="ratingFilterEnabled"
      :label="$t('CSAT_REPORTS.METRIC.SATISFACTION_SCORE.LABEL')"
      :info-text="$t('CSAT_REPORTS.METRIC.SATISFACTION_SCORE.TOOLTIP')"
      :value="ratingFilterEnabled ? '--' : formatToPercent(satisfactionScore)"
    />
    <csat-metric-card
      :label="$t('CSAT_REPORTS.METRIC.RESPONSE_RATE.LABEL')"
      :info-text="$t('CSAT_REPORTS.METRIC.RESPONSE_RATE.TOOLTIP')"
      :value="formatToPercent(responseRate)"
    />
    <csat-metric-card
      :label="$t('CSAT_REPORTS.METRIC.FIST_CONTACT_RESOLUTION.LABEL')"
      :info-text="$t('CSAT_REPORTS.METRIC.FIST_CONTACT_RESOLUTION.TOOLTIP')"
      :value="formatToPercent(fistContactResolution)"
    />
    <div
      v-if="metrics.totalResponseCount && !ratingFilterEnabled"
      class="medium-6 report-card"
    >
      <h3 class="heading">
        <div class="emoji--distribution">
          <div
            v-for="(rating, key, index) in ratingPercentage"
            :key="rating + key + index"
            class="emoji--distribution-item"
          >
            <span class="emoji--distribution-key">{{
              ratingToEmoji(key)
            }}</span>
            <span>{{ formatToPercent(rating) }}</span>
          </div>
        </div>
      </h3>
      <div v-if="satisfactionScore" class="emoji--distribution-chart">
        <woot-horizontal-bar :collection="chartData" :height="24" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import CsatMetricCard from './CsatMetricCard';
import { CSAT_RATINGS } from 'shared/constants/messages';

export default {
  components: {
    CsatMetricCard,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      csatRatings: CSAT_RATINGS,
    };
  },
  computed: {
    ...mapGetters({
      metrics: 'csat/getMetrics',
      ratingPercentage: 'csat/getRatingPercentage',
      satisfactionScore: 'csat/getSatisfactionScore',
      responseRate: 'csat/getResponseRate',
    }),
    ratingFilterEnabled() {
      return Boolean(this.filters.rating);
    },
    chartData() {
      return {
        labels: ['Rating'],
        datasets: CSAT_RATINGS.map(rating => ({
          label: rating.emoji,
          data: [this.ratingPercentage[rating.value]],
          backgroundColor: rating.color,
        })),
      };
    },
    responseCount() {
      return this.metrics.totalResponseCount
        ? this.metrics.totalResponseCount.toLocaleString()
        : '--';
    },
    totalSentMessagesCount() {
      return this.metrics.totalSentMessagesCount
        ? this.metrics.totalSentMessagesCount.toLocaleString()
        : '--';
    },
    fistContactResolution() {
      const resultFistContactResolution = this.metrics.fistContactResolution;

      if(resultFistContactResolution == null) {
        return '';
      }
      const formatted_number = resultFistContactResolution % 1 !== 0 ? 
        resultFistContactResolution.toFixed(2) : 
        resultFistContactResolution;

      return formatted_number;
    },
  },
  methods: {
    formatToPercent(value) {
      if(value == null){
        return '--'
      }
      return `${value}%`
    },
    ratingToEmoji(value) {
      return CSAT_RATINGS.find(rating => rating.value === Number(value)).emoji;
    },
  },
};
</script>
<style lang="scss" scoped>
.csat--metrics-container {
  background: var(--color-surface);
  margin-bottom: var(--space-two);
  border-radius: var(--border-radius-normal);
  border: 1px solid var(--color-border);
  padding: var(--space-normal);
}

.emoji--distribution {
  display: flex;
  justify-content: flex-end;

  .emoji--distribution-item {
    padding-left: var(--space-normal);
  }
}

.emoji--distribution-chart {
  margin-top: var(--space-small);
}

.emoji--distribution-key {
  margin: 0 var(--space-micro);
}
</style>
